import stringPadStart from 'string.prototype.padstart';

export default function padStart(str, length, char) {
    if(String.prototype.padStart === undefined) {
        return stringPadStart(str, length, char);
    }
    return str.padStart(length, char);
}
